import React, { useEffect } from "react";
import BackgroundImage from "../assets/images/about/mountain-sun.jpg";
import AboutImage1 from "../assets/images/about/periodic-table.jpg";
import AboutImage2 from "../assets/images/about/health.jpg";
import Layout from '../components/layoutBlack';
import Breadcrumbs from '../components/breadcrumbs';

const About = () => {
        useEffect(() => {
            window.scrollTo(0, 0);
          }, []);
    return (
        <div>
            <Layout>
            {/* Title Section */}
            {/* <section
                className="bg-img1 txt-center p-lr-15 p-tb-92"
                style={{ backgroundImage: `url(${BackgroundImage})` }}
            >
                <h2 className="ltext-105 cl0 txt-center">About</h2>
            </section> */}

            <div className="container p-t-80 p-b-10">
            <Breadcrumbs />
            </div>

            {/* Content Section */}
            <section className="full-page-section bg0 p-t-40 p-b-120">
                <div className="container">
                    {/* Our Story Section */}
                        <div className="row p-b-148">
                        <div className="col-md-7 col-lg-8">
                            <div className="p-t-7 p-r-85 p-r-15-lg p-r-0-md">
                                <h3 className="mtext-111 cl2 p-b-16">Our Story</h3>
                                <p className="stext-113 cl6 p-b-26">
                                After years of watching patients struggle with harsh hair loss treatments and disappointing natural remedies, 
                                I knew there had to be a better way. As both a chemist and naturopathic doctor, I was uniquely positioned to 
                                find it. Molu started with one product: Hair Growth Fuel—built around 2-deoxy-D-ribose (2dDR) and a belief 
                                that hair care should be engineered, not guessed. Since then, we've obsessed over research and formulation—incorporating 
                                copper peptides, developing our proprietary Lactate/Pyruvate Complex, and evolving into what became Molu Advanced 
                                Hair Growth Fuel.
                                </p>
                                <p className="stext-113 cl6 p-b-26">
                                That same science-first approach led us into skincare. We focused on ingredients with strong track records—copper 
                                peptides, pterostilbene, niacinamide, and hyaluronic acid—then refined the texture, absorption, and performance 
                                until the formulas felt as good as they worked. We also developed our proprietary Ionic Peptide Delivery Complex™ 
                                to support our peptide systems and push our formulas further.
                                </p>
                                <p className="stext-113 cl6 p-b-26">
                                As a small company, we can iterate quickly, stay close to emerging science, and improve products without compromise—advantages 
                                that larger companies simply don't have. But here's what matters most: we use our own products. Every formula we create 
                                meets the standard we demand for ourselves, because we believe you deserve the same level of care and efficacy that we 
                                want in our own routines.
                                </p>
                                <p className="stext-113 cl6 p-b-26">
                                Molu exists to offer solutions—effective, affordable, and evidence-led—so your routine delivers results you can actually 
                                see and feel. We're not here to sell marketing hype. We're here to provide science-driven products that advance your 
                                wellness and confidence, because your success defines our success.
                                </p>
                            </div>
                        </div>
                        <div className="col-11 col-md-5 col-lg-4 m-lr-auto">
                            <div className="how-bor1">
                                <div className="hov-img0">
                                    <img src={AboutImage1} alt="Our Story" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Our Mission Section */}
                    <div className="row">
                        <div className="order-md-2 col-md-7 col-lg-8 p-b-30">
                            <div className="p-t-7 p-l-85 p-l-15-lg p-l-0-md">
                                <h3 className="mtext-111 cl2 p-b-16">Our Mission</h3>
                                <p className="stext-113 cl6 p-b-26">
                                Our mission is to provide effective, science-driven solutions that advance your wellness and confidence at an affordable 
                                price. We're committed to staying on the cutting edge of scientific development, rapidly translating breakthrough research 
                                into products that deliver real, measurable results—not marketing hype. Every formula we create meets the standard we demand 
                                for ourselves, because we use our own products and believe you deserve the same level of care. Your success defines our 
                                success, and we're here to offer evidence-led solutions you can actually see and feel.
                                </p>
                                <div className="bor16 p-l-29 p-b-9 m-t-22">
                                    <p className="stext-114 cl6 p-r-40 p-b-11">
                                    Both health and sickness are the accumulation of small things that we do each day.
                                    </p>
                                    <span className="stext-111 cl8">- Molu Founder</span>
                                </div>
                            </div>
                        </div>
                        <div className="order-md-1 col-11 col-md-5 col-lg-4 m-lr-auto p-b-30">
                            <div className="how-bor2">
                                <div className="hov-img0">
                                    <img src={AboutImage2} alt="Our Mission" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </Layout>
        </div>
    );
};

export default About;
